import React from "react";
import GoToPage from "./goToPage";
const GroupsDualTile = (props) => {
  const { 
  ico, 
  title, 
  subTile, 
  linkPage,
  linkSide,
  linkName,
  linkFontsize,
  linkTextColor,
  linkBorderType,
  linkBorderColor,
  linkIconSize,
  linkIconColor,
  linkIconMargin  } = props;
  return (
    <div className="grid grid-cols-1 pt-10 w-fit h-full relative z-10">
      <div className="">
        <img loading="lazy" src={ico} className="mb-10 ml-10"></img>
      </div>
      <div className=" grid grid-cols-1 mt-10 pb-10">
        <div className="">
          {title}
        </div>
        <div className="mt-2 pl-10">
          <GoToPage
            page={linkPage}
            side={linkSide}
            name={linkName}
            fontSize={linkFontsize}
            textColor={linkTextColor}
            borderType={linkBorderType}
            borderColor={linkBorderColor}
            iconSize={linkIconSize}
            iconColor={linkIconColor}
            iconMargin={linkIconMargin}
          ></GoToPage>
        </div>
      </div>
    </div>
  );
};

export default GroupsDualTile;
